<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-50">
    <div class="text-center">
      <div class="w-8 h-8 border-4 border-orange-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
      <p class="text-gray-600">Redirecting...</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('tenant', ['isOnlyReadOnlyUser', 'isRestrictedToPortal'])
  },
  mounted() {
    if (this.isRestrictedToPortal) {
      this.$router.replace('/portal')
    } else if (this.isOnlyReadOnlyUser) {
      this.$router.replace('/engage')
    } else {
      this.$router.replace('/insight')
    }
  }
}
</script>
